import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  '& $card, $cardContent': {
    color: TextColors.dark,
  },
  '& $caption': {
    color: hexToRGBA(TextColors.dark, TextOpacities.light1),
  },
  '& $category': {
    color: SecondaryColors.main,
  },
};

const darkTheme = {
  '& $card, $cardContent': {
    color: TextColors.light,
  },
  '& $caption': {
    color: hexToRGBA(TextColors.light, TextOpacities.light1),
  },
  '& $category': {
    color: SecondaryColors.dark,
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    bgCard: {
      '&.dark-theme': darkTheme,
      '&.light-theme': lightTheme,
    },
    card: {
      height: '100%',
      width: '100%',
      position: 'relative',
    },
    cardContent: {
      '&.MuiCardContent-root': {
        padding: muiTheme.spacing(4),

        '&.MuiCardContent-root:last-of-type': {
          paddingBottom: muiTheme.spacing(4),
        },
      },
    },
    cardLogo: {
      maxHeight: '65px',

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },

      '& img': {
        height: '100%',
        maxHeight: '65px',
        width: 'auto',
      },
    },
    category: {
      '&.Muitypography-root': {
        marginBottom: muiTheme.spacing(1),
      },
    },
    categoryTop: () => ({
      marginBottom: muiTheme.spacing(2),
    }),
    cardHeading: {
      '&.MuiTypography-root': {
        color: 'inherit',

        '&:not(:last-child)': {
          marginBottom: muiTheme.spacing(2),
        },
      },
    },
    cardDescription: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },
    },
    cardActions: {
      padding: 0,

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },

      '& .box': {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',

        [muiTheme.breakpoints.down('xs')]: {
          alignItems: 'baseline',
          flexDirection: 'column',
        },
      },
    },
    cardActionsCol: {
      '&': {
        [muiTheme.breakpoints.down('xs')]: {
          flex: '0 0 50%',
          '&:nth-child(2)': {
            marginTop: muiTheme.spacing(2),
          },
        },
      },
    },
    cardInfo: {
      '& p': {
        margin: '0 !important',
      },
    },
    caption: {},
    primaryCTA: {
      marginTop: muiTheme.spacing(2),
    },
    divider: {
      padding: '0 8px',
    },
    cardLink: {
      '&.MuiButtonBase-root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
        top: 0,
        left: 0,
      },
    },
    cardActionsLink: {
      '&.MuiButtonBase-root': {
        position: 'relative',
        zIndex: 2,
      },
    },
    cardCta: {
      zIndex: 2,
    },
  }),
  { name: 'GenFeaturedContentCustomerCard' },
);

export default useStyles;
